<template>
    <div id="Settings-menu">
        <div class="header">
            <span class="md-icon" @click="$emit('close')">close</span>
            {{ title }}
        </div>
        <div class="content">
            <TitleSettings
                v-if="type === 'title'"
                :item="item"
                @update-title-size="updateTitleSize"
                @update-text-align="updateTextAlign"
                @update-title-text="updateTitleText"
                @update-subtitle-text="updateSubTitleText"
            />
            <FullNameSettings
                v-if="type === 'fullName'"
                :item="item"
                @update-field-label="updateFieldLabel"
                @update-label-align="updateLabelAlign"
                @update-first-name="updateFirstName"
                @update-last-name="updateLastName"
                @update-required="updateRequired"
            />
            <EmailSettings
                v-if="type === 'email'"
                :item="item"
                @update-field-email="updateFieldEmail"
                @update-label-align-mail="updateLabelAlignMail"
                @update-alt-label-mail="updateAltLabelMail"
                @update-required="updateRequired"
            />
            <AddressSettings
                v-if="type === 'address'"
                :item="item"
                @update-field-label-address="updateFieldLabelAddress"
                @update-label-align-address="updateLabelAlignAddress"
                @update-field-address-line-1="updateFieldAddressLine1"
                @update-field-address-line-2="updateFieldAddressLine2"
                @update-field-district="updateFieldDistrict"
                @update-field-postal-code="updateFieldPostalCode"
                @update-field-state="updateFieldState"
                @update-required="updateRequired"
            />
            <PhoneSettings
                v-if="type === 'phone'"
                :item="item"
                @update-field-phone="updateFieldPhone"
                @update-label-align-phone="updateLabelAlignPhone"
                @update-masked-phone="updateMaskedPhone"
                @update-required="updateRequired"
            />
            <DatePickerSettings
                v-if="type === 'datePicker'"
                :item="item"
                @update-field-label-date-picker="updateFieldLabelDatePicker"
                @update-label-align-date-picker="updateLabelAlignDatePicker"
                @update-date-label-date-picker="updateDateLabelDatePicker"
                @update-required="updateRequired"
            />
            <ShortTextSettings
                v-if="type === 'shortText'"
                :item="item"
                @update-field-label-short-text="updateFieldLabelShortText"
                @update-label-align-short-text="updateLabelAlignShortText"
                @update-alt-label-short-text="updateAltLabelShortText"
                @update-required="updateRequired"
            />
            <LongTextSettings
                v-if="type === 'longText'"
                :item="item"
                @update-field-label-long-text="updateFieldLabelLongText"
                @update-label-align-long-text="updateLabelAlignLongText"
                @update-alt-label-long-text="updateAltLabelLongText"
                @update-required="updateRequired"
            />
            <DropDownListSettings
                v-if="type === 'dropDownList'"
                :item="item"
                @update-field-label-drop-down-list="updateFieldLabelDropDownList"
                @update-placeholder-drop-down-list="updatePlaceholderDropDownList"
                @update-label-align-drop-down-list="updateLabelAlignDropDownList"
                @update-alt-label-drop-down-list="updateAltLabelDropDownList"
            />
            <SingleChoiceSettings
                v-if="type === 'singleChoice'"
                :item="item"
                @update-field-label-single-choice="updateFieldLabelSingleChoice"
                @update-label-align-single-choice="updateLabelAlignSingleChoice"
            />
            <MultipleSelectionSettings
                v-if="type === 'multipleSelection'"
                :item="item"
                @update-field-label-multiple-selection="updateFieldLabelMultipleSelection"
                @update-label-align-multiple-selection="updateLabelAlignMultipleSelection"
            />
            <NumberSettings
                v-if="type === 'number'"
                :item="item"
                @update-field-label-number="updateFieldLabelNumber"
                @update-label-align-number="updateLabelAlignNumber"
                @update-sub-label-number="updateSubLabelNumber"
                @update-required="updateRequired"
            />
            <HourSettings
                v-if="type === 'hour'"
                :item="item"
                @update-field-label-hour="updateFieldLabelHour"
                @update-label-align-hour="updateLabelAlignHour"
                @update-hour-label="updateHourLabel"
                @update-minute-label="updateMinuteLabel"
                @update-required="updateRequired"
            />
            <SpinnerSettings
                v-if="type === 'spinner'"
                :item="item"
                @update-field-label-spinner="updateFieldLabelSpinner"
                @update-label-align-spinner="updateLabelAlignSpinner"
                @update-required="updateRequired"
            />
            <SendSettings
                v-if="type === 'send'"
                :item="item"
                @update-send-label="updateFieldLabelSend"
                @update-label-align-send="updateAlignmentSend"
            />

            <StarRatingSettings
                v-if="type === 'starRating'"
                :item="item"
                @update-field-label-star-rating="updateFieldLabelStarRating"
                @update-alignment-star-rating="updateAlignmentStarRating"
            />
            <RatingScaleSettings
                v-if="type === 'ratingScale'"
                :item="item"
                @update-field-label-rating-scale="updateFieldLabelRatingScale"
                @update-alignment-rating-scale="updateAlignmentRatingScale"
                @update-sub-label-one-rating-scale="updateRatingScaleSubLabelOne"
                @update-sub-label-two-rating-scale="updateRatingScaleSubLabelTwo"
            />
            <SeparationElementSettings
                v-if="type === 'separationElement'"
                :item="item"
                @update-separation-color="updateSeparationColor"
                @update-separator-style="updateSeparatorStyle"
                @update-separator-height="updateSeparatorHeight"
                @update-separator-bottom="updateSeparatorBottom"
                @update-separator-top="updateSeparatorTop"
                @update-separator-side="updateSeparatorSide"
            />
            <FileUploadSettings
                v-if="type === 'fileUpload'"
                :item="item"
                @update-file-label="updateFileLabel"
                @update-file-alt-label-one="updateFileAltLabelOne"
                @update-file-alt-label-two="updateFileAltLabelTwo"
                @update-file-align="updateFileAlign"
                @update-file-required="updateRequired"
            />
        </div>
    </div>
</template>
<script>
import TitleSettings from "./TitleSettings.vue";
import FullNameSettings from "./FullNameSettings.vue";
import EmailSettings from "./EmailSettings.vue";
import AddressSettings from "./AddressSettings.vue";
import PhoneSettings from "./PhoneSettings.vue";
import DatePickerSettings from "./DatePickerSettings.vue";
import ShortTextSettings from "./ShortTextSettings.vue";
import LongTextSettings from "./LongTextSettings.vue";
import DropDownListSettings from "./DropDownListSettings.vue";
import SingleChoiceSettings from "./SingleChoiceSettings.vue";
import MultipleSelectionSettings from "./MultipleSelectionSettings.vue";
import NumberSettings from "./NumberSettings.vue";
import HourSettings from "./HourSettings.vue";
import SpinnerSettings from "./SpinnerSettings.vue";
import SendSettings from "./SendSettings.vue";
import StarRatingSettings from "./StarRatingSettings.vue";
import RatingScaleSettings from "./RatingScaleSettings.vue";
import SeparationElementSettings from "./SeparationElementSettings.vue";
import FileUploadSettings from "./FileUploadSettings.vue";

export default {
    name: "SettingsMenu",
    components: {
        TitleSettings,
        FullNameSettings,
        EmailSettings,
        AddressSettings,
        PhoneSettings,
        DatePickerSettings,
        ShortTextSettings,
        LongTextSettings,
        DropDownListSettings,
        SingleChoiceSettings,
        MultipleSelectionSettings,
        NumberSettings,
        HourSettings,
        SpinnerSettings,
        SendSettings,
        StarRatingSettings,
        RatingScaleSettings,
        SeparationElementSettings,
        FileUploadSettings,
    },
    props: {
        type: {
            type: String,
            required: true,
        },
        item: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            title: "Ayarlar",
        };
    },
    methods: {
        menuTitle() {
            if (this.type === "title") {
                return (this.title = "Başlık Ayarları");
            } else if (this.type === "fullName") {
                return (this.title = "Tam Ad Ayarları");
            } else if (this.type === "email") {
                return (this.title = "E-posta Ayarları");
            } else if (this.type === "address") {
                return (this.title = "Adres Ayarları");
            } else if (this.type === "phone") {
                return (this.title = "Telefon Ayarları");
            } else if (this.type === "datePicker") {
                return (this.title = "Tarih Seçici Ayarları");
            } else if (this.type === "shortText") {
                return (this.title = "Kısa Metin Ayarları");
            } else if (this.type === "longText") {
                return (this.title = "Uzun Metin Ayarları");
            } else if (this.type === "dropDownList") {
                return (this.title = "Açılır Liste Ayarları");
            } else if (this.type === "singleChoice") {
                return (this.title = "Tek Seçim Ayarları");
            } else if (this.type === "multipleSelection") {
                return (this.title = "Çoklu Seçim Ayarları");
            } else if (this.type === "number") {
                return (this.title = "Sayı Ayarları");
            } else if (this.type === "hour") {
                return (this.title = "Saat Ayarları");
            } else if (this.type === "spinner") {
                return (this.title = "Spinner Ayarları");
            } else if (this.type === "send") {
                return (this.title = "Gönderme Ayarları");
            } else if (this.type === "starRating") {
                return (this.title = "Yıldız Derecelendirme Ayarları");
            } else if (this.type === "ratingScale") {
                return (this.title = "Derecelendirme Ölçeği Ayarları");
            } else if (this.type === "separationElement") {
                return (this.title = "Ayırma Elemanı Ayarları");
            }
        },
        updateTitleSize(size) {
            this.$emit("update-title-size", size);
        },
        updateTextAlign(align) {
            this.$emit("update-text-align", align);
        },
        updateTitleText(text) {
            this.$emit("update-title-text", text);
        },
        updateSubTitleText(text) {
            this.$emit("update-subtitle-text", text);
        },
        updateFieldLabel(label) {
            this.$emit("update-field-label", label);
        },
        updateLabelAlign(align) {
            this.$emit("update-label-align", align);
        },
        updateFirstName(name) {
            this.$emit("update-first-name", name);
        },
        updateLastName(name) {
            this.$emit("update-last-name", name);
        },
        updateFieldEmail(email) {
            this.$emit("update-field-email", email);
        },
        updateLabelAlignMail(align) {
            this.$emit("update-label-align-mail", align);
        },
        updateAltLabelMail(label) {
            this.$emit("update-alt-label-mail", label);
        },
        updateFieldLabelAddress(label) {
            this.$emit("update-field-label-address", label);
        },
        updateLabelAlignAddress(align) {
            this.$emit("update-label-align-address", align);
        },
        updateFieldAddressLine1(address) {
            this.$emit("update-field-address-line-1", address);
        },
        updateFieldAddressLine2(address) {
            this.$emit("update-field-address-line-2", address);
        },
        updateFieldDistrict(district) {
            this.$emit("update-field-district", district);
        },
        updateFieldPostalCode(postalCode) {
            this.$emit("update-field-postal-code", postalCode);
        },
        updateFieldState(state) {
            this.$emit("update-field-state", state);
        },
        updateFieldPhone(phone) {
            this.$emit("update-field-phone", phone);
        },
        updateLabelAlignPhone(align) {
            this.$emit("update-label-align-phone", align);
        },
        updateMaskedPhone(masked) {
            this.$emit("update-masked-phone", masked);
        },
        updateFieldLabelDatePicker(label) {
            this.$emit("update-field-label-date-picker", label);
        },
        updateLabelAlignDatePicker(align) {
            this.$emit("update-label-align-date-picker", align);
        },
        updateDateLabelDatePicker(label) {
            this.$emit("update-date-label-date-picker", label);
        },
        updateFieldLabelShortText(label) {
            this.$emit("update-field-label-short-text", label);
        },
        updateLabelAlignShortText(align) {
            this.$emit("update-label-align-short-text", align);
        },
        updateAltLabelShortText(label) {
            this.$emit("update-alt-label-short-text", label);
        },
        updateFieldLabelLongText(label) {
            this.$emit("update-field-label-long-text", label);
        },
        updateLabelAlignLongText(align) {
            this.$emit("update-label-align-long-text", align);
        },
        updateAltLabelLongText(label) {
            this.$emit("update-alt-label-long-text", label);
        },
        updateFieldLabelDropDownList(label) {
            this.$emit("update-field-label-drop-down-list", label);
        },
        updatePlaceholderDropDownList(placeholder) {
            this.$emit("update-placeholder-drop-down-list", placeholder);
        },
        updateLabelAlignDropDownList(align) {
            this.$emit("update-label-align-drop-down-list", align);
        },
        updateAltLabelDropDownList(label) {
            this.$emit("update-alt-label-drop-down-list", label);
        },
        updateFieldLabelSingleChoice(label) {
            this.$emit("update-field-label-single-choice", label);
        },
        updateLabelAlignSingleChoice(align) {
            this.$emit("update-label-align-single-choice", align);
        },
        updateFieldLabelMultipleSelection(label) {
            this.$emit("update-field-label-multiple-selection", label);
        },
        updateLabelAlignMultipleSelection(align) {
            this.$emit("update-label-align-multiple-selection", align);
        },
        updateFieldLabelNumber(label) {
            this.$emit("update-field-label-number", label);
        },
        updateLabelAlignNumber(align) {
            this.$emit("update-label-align-number", align);
        },
        updateSubLabelNumber(subLabel) {
            this.$emit("update-sub-label-number", subLabel);
        },
        updateFieldLabelHour(label) {
            this.$emit("update-field-label-hour", label);
        },
        updateLabelAlignHour(align) {
            this.$emit("update-label-align-hour", align);
        },
        updateHourLabel(label) {
            this.$emit("update-hour-label", label);
        },
        updateMinuteLabel(label) {
            this.$emit("update-minute-label", label);
        },
        updateFieldLabelSpinner(label) {
            this.$emit("update-field-label-spinner", label);
        },
        updateFieldLabelSend(label) {
            this.$emit("update-field-label-send", label);
        },
        updateAlignmentSend(align) {
            this.$emit("update-label-align-send", align);
        },
        updateLabelAlignSpinner(align) {
            this.$emit("update-label-align-spinner", align);
        },
        updateFieldLabelStarRating(label) {
            this.$emit("update-field-label-star-rating", label);
        },
        updateAlignmentStarRating(align) {
            this.$emit("update-alignment-star-rating", align);
        },
        updateFieldLabelRatingScale(label) {
            this.$emit("update-field-label-rating-scale", label);
        },
        updateAlignmentRatingScale(align) {
            this.$emit("update-alignment-rating-scale", align);
        },
        updateRatingScaleSubLabelOne(label) {
            this.$emit("update-sub-label-one-rating-scale", label);
        },
        updateRatingScaleSubLabelTwo(label) {
            this.$emit("update-sub-label-two-rating-scale", label);
        },
        updateSeparationColor(color) {
            this.$emit("update-separation-color", color);
        },
        updateSeparatorStyle(style) {
            this.$emit("update-separator-style", style);
        },
        updateSeparatorHeight(height) {
            this.$emit("update-separator-height", height);
        },
        updateSeparatorBottom(bottom) {
            this.$emit("update-separator-bottom", bottom);
        },
        updateSeparatorTop(top) {
            this.$emit("update-separator-top", top);
        },
        updateSeparatorSide(side) {
            this.$emit("update-separator-side", side);
        },
        updateFileLabel(label) {
            this.$emit("update-file-label", label);
        },
        updateFileAltLabelOne(label) {
            this.$emit("update-file-alt-label-one", label);
        },
        updateFileAltLabelTwo(label) {
            this.$emit("update-file-alt-label-two", label);
        },
        updateFileAlign(align) {
            this.$emit("update-file-align", align);
        },
        updateRequired(required) {
            this.$emit("update-required", required);
        },
    },
    mounted() {
        this.menuTitle();
    },
};
</script>

<style lang="scss" scoped>
#Settings-menu {
    max-width: 320px;
    background-color: #fff;
    overflow: hidden;
    font-family: "Roboto", sans-serif;
    border-left: 1px solid #ddd;
    height: 100vh;
    position: absolute;
    right: 0;
    top: 0;

    .header {
        display: -webkit-box;
        gap: 50px;
        display: -ms-flexbox;
        justify-content: flex-start;
        -ms-flex-pack: justify;
        -webkit-box-align: center;
        -ms-flex-align: center;
        align-items: center;
        padding: 15px;
        background-color: #33384a;
        color: #ffffff;

        .md-icon {
            font-size: 1.5rem;
            cursor: pointer;
            margin-right: 20px;
        }
    }

    .content {
        padding: 15px 15px 200px 15px;
        overflow: scroll;
        height: 100vh;
    }
}
</style>
